import { memo } from "react";

type Props = {
	text: string;
};

export const Empty = memo(({ text }: Props) => {
	return (
		<div className="rounded bg-bg-layer-200 p-4 text-center text-sm md:text-base">
			<p className="font-semibold">{text}</p>
		</div>
	);
});
